export default "__VITE_ASSET__Cr7Nf_Zi__"